import React from "react";
import AvatarGroup from "./AvatarGroup";

interface Owner {
  avatar?: string | null;
  name?: string;
  email?: string;
}

interface OwnerCellProps {
  owners: Owner[];
}

/**
 * Renders the "Owner" column cell: a compact avatar group or a "—" fallback.
 * Accepts the raw owners array from the ExpiryItem and handles the mapping
 * to AvatarGroup's required prop shape in one place.
 */
const OwnerCell: React.FC<OwnerCellProps> = ({ owners }) => {
  if (!owners || owners.length === 0) {
    return <span className="text-[#9CA3AF]">—</span>;
  }

  return (
    <AvatarGroup
      avatars={owners.map((o) => ({
        src: o.avatar ?? undefined,
        name: o.name ?? o.email ?? "",
        alt: o.name ?? o.email ?? "",
      }))}
      max={2}
      size="sm"
    />
  );
};

export default OwnerCell;
